import { render, staticRenderFns } from "./ModalSalvamentoContencao.vue?vue&type=template&id=8ebad1bc"
import script from "./ModalSalvamentoContencao.vue?vue&type=script&lang=js"
export * from "./ModalSalvamentoContencao.vue?vue&type=script&lang=js"
import style0 from "./ModalSalvamentoContencao.vue?vue&type=style&index=0&id=8ebad1bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports